// my-app/src/main.ts
import { createAppInstance } from './config/app'
import { initializeLogger } from './config/logger'
import { setupUnauthorizedHandler, checkAuthStatus } from './config/auth'
import router from './router'

// Initialize logger
initializeLogger()

// Create app instance with plugins
const { app } = createAppInstance()

// Setup auth handlers
setupUnauthorizedHandler()

// Check auth status before mounting
checkAuthStatus().finally(() => {
  app.use(router).mount('#app')
})
